import appApi from '../../../../api/app-api';
import globalSettingsStores from '../../../../stores/settings-stores';
import { toast } from 'react-toastify';
import globalSettingsBranches from '../../../../stores/global-settings-branches';

export enum SettingsEntityType {
  BRANCH = 'branch',
  BUILDING = 'building',
  MAJOR = 'major',
  ASSIGNMENT_TYPE = 'assignment_type',
  EXAM_TYPE = 'exam_type',
  SUPERVISORY_INSTITUTION = 'supervisory_institution',
  LECTURER_RATE = 'lecturer_rate',
  PAYMENT_TYPE = 'PAYMENT_TYPE',
  SCHOLARSHIP_FUNDER = 'SCHOLARSHIP_FUNDER',
  DOC_TYPE = 'DOC_TYPE',
  COURSE_STUDENT_STATUS = 'COURSE_STUDENT_STATUS',
}

const handleExisting = (names: string[], entityName: string) => {
  const set = new Set(names);
  if (set.has(entityName)) {
    toast.warn('שם זה קיים במערכת');
    return true;
  }
  return false;
};

export const operateUpdateSettingEntityApiCall = async (
  entityType: SettingsEntityType,
  entityId: number,
  majorName: string,
) => {
  switch (entityType) {
    case SettingsEntityType.MAJOR:
      const isExistingMajor = handleExisting(
        globalSettingsStores.majors
          .filter((item) => item.id !== entityId)
          .map((item) => item.majorName),
        majorName,
      );
      if (!isExistingMajor) {
        await appApi.editMajorName(entityId, majorName);
      }
      break;
    case SettingsEntityType.ASSIGNMENT_TYPE:
      const isExistingAssignmentType = handleExisting(
        globalSettingsStores.assignmentTypes
          .filter((item) => item.id !== entityId)
          .map((item) => item.assignmentTypeName),
        majorName,
      );
      if (!isExistingAssignmentType) {
        await appApi.editAssignmentTypeName(entityId, majorName);
      }
      break;
    case SettingsEntityType.EXAM_TYPE:
      const isExistingExamType = handleExisting(
        globalSettingsStores.examTypes
          .filter((item) => item.id !== entityId)
          .map((item) => item.examTypeName),
        majorName,
      );
      if (!isExistingExamType) {
        await appApi.editExamTypeName(entityId, majorName);
      }
      break;
    case SettingsEntityType.SUPERVISORY_INSTITUTION:
      const isExistingSupervisoryInstitution = handleExisting(
        globalSettingsStores.supervisoryInstitution
          .filter((item) => item.id !== entityId)
          .map((item) => item.institutionName),
        majorName,
      );
      if (!isExistingSupervisoryInstitution) {
        await appApi.editSupervisoryInstitutionName(entityId, majorName);
      }
      break;
    case SettingsEntityType.LECTURER_RATE:
      const isExistingLecturerRate = handleExisting(
        globalSettingsStores.lecturersTypeRateNames
          .filter((item) => item.id !== entityId)
          .map((item) => item.typeRateName),
        majorName,
      );
      if (!isExistingLecturerRate) {
        await appApi.editLecturerRateName(entityId, majorName);
      }
      break;
    case SettingsEntityType.PAYMENT_TYPE:
      const isExistingPaymentType = handleExisting(
        globalSettingsStores.servicePaymentTypes
          .filter((item) => item.id !== entityId)
          .map((item) => item.paymentServiceTypeName),
        majorName,
      );
      if (!isExistingPaymentType) {
        await appApi.editPaymentServiceTypeName(entityId, majorName);
      }
      break;
    case SettingsEntityType.SCHOLARSHIP_FUNDER:
      const isExistingScholarshipFunder = handleExisting(
        globalSettingsStores.scholarshipFunders
          .filter((item) => item.id !== entityId)
          .map((item) => item.funderName),
        majorName,
      );
      if (!isExistingScholarshipFunder) {
        await appApi.editScholarshipFunder(entityId, majorName);
      }
      break;
    case SettingsEntityType.DOC_TYPE:
      const isExistingDocType = handleExisting(
        globalSettingsStores.docTypes
          .filter((item) => item.id !== entityId)
          .map((item) => item.docTypeName),
        majorName,
      );
      if (!isExistingDocType) {
        await appApi.editDocTypeName(entityId, majorName);
      }
      break;
    case SettingsEntityType.COURSE_STUDENT_STATUS:
      const isExistingCourseStudentStatus = handleExisting(
        globalSettingsStores.courseStudentStatuses
          .filter((item) => item.id !== entityId)
          .map((item) => item.statusName),
        majorName,
      );
      if (!isExistingCourseStudentStatus) {
        await appApi.editCourseStudentStatus(entityId, majorName);
      }
      break;
    case SettingsEntityType.BRANCH:
      const isExistingBranch = handleExisting(
        globalSettingsBranches.branches
          .filter((item) => item.id !== entityId)
          .map((item) => item.branchName),
        majorName,
      );
      if (!isExistingBranch) {
        await appApi.editBranchName(entityId, majorName);
      }
      break;
    case SettingsEntityType.BUILDING:
      const isExistingBuilding = handleExisting(
        globalSettingsBranches.buildings
          .filter((item) => item.id !== entityId)
          .map((item) => item.buildingName),
        majorName,
      );
      if (!isExistingBuilding) {
        await appApi.editBuilding(entityId, majorName);
      }
      break;
  }
};
